import { useState } from 'react';
import classes from './SwitchToggle.module.css'

const SwitchToggle = ({ checked, setChecked, id }) => {

  const toggleChecked = () => setChecked(checked => !checked);
  return (
    <>
      <input
        className={classes.SwitchCheckbox}
        id={id}
        type="checkbox"
        checked={checked}
        onChange={toggleChecked}
      />
      <label
        className={classes.SwitchLabel}
        htmlFor={id}
      >
        <span className={classes.SwitchButton} />
      </label>
    </>
  );

}
export default SwitchToggle